<template>
  <div v-if="infos.page.content">
    <v-card row class="ma-2">
      <v-card-title primary-title class="grey lighten-4">
        <h3 class="title mb-0">{{ infos.title }}</h3>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <div v-html="infos.page.content" class="subheading"></div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      infos: {
        title: '',
        address: '',
        content: '',
        email: '',
        page: ''
      }

    }
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.fetchData()
  },
  watch: {
    // call again the method if the route changes
   // '$route': 'fetchData'
  },
  methods: {
    fetchData () {
      const app = this
        // const id = app.$route.params.id

      axios.get('/api/v1/infos/newsbox')
                .then(function (resp) {
                  app.infos = resp.data
                })
                .catch(function () {
                   // alert("Konnte Firma nicht laden")
                  console.log('info error')
                    // app.$router.push('/')
                })
    }

  },
  metaInfo () {
    return { title: this.infos.title }
  }
}
</script>